module.exports = __webpack_public_path__ + "media/game-win-2.d7bf2473.mp3";